import React from "react";
import { Box, IconButton } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

import { withShowIf } from "../../../with-show-if/with-show-If.component";

import { UserRemoveButtonProps } from "./user-remove-button.props";

export const UserRemoveButton = withShowIf((props: UserRemoveButtonProps) => {
  return (
    <Box>
      <IconButton
        edge="end"
        disabled={props.isDisabled}
        onClick={() => {
          props.onRemove(props.id);
        }}
        title="Delete"
      >
        <CloseIcon />
      </IconButton>
    </Box>
  );
});
